export default function pushToDataLayer(eventCategory, eventAction, eventLabel, eventNonInteraction = false) {
    return window.dataLayer.push({
        event: 'gaEvent',
        eventCategory,
        eventAction,
        eventLabel,
        eventNonInteraction,
    });
}
